// @flow

import GoogleAnalytics from 'react-ga'

const trackButtonClick = (name: string) => {
  GoogleAnalytics.event({
    category: 'Button',
    action: 'Click',
    label: name
  })
}

export default trackButtonClick
